import {
  redoMarketCountryIdFormat,
  redoMarketIdFormat,
} from "@redotech/redo-model/ids";
import * as z from "zod";
import { pricingInclusionMode } from "./pricing-inclusion-mode";

/** Shared output shapes for the merchant-facing `redo_market` endpoints.
 * `source` and `shopCurrency` are derived server-side from the team, so
 * they're returned but never accepted as input. */
export const redoMarketOutput = z.object({
  id: redoMarketIdFormat.schema,
  source: z.string(),
  shopCurrency: z.string(),
  /** Merchant-set display name; null/absent means use the auto-generated
   * label. Optional so the field can be safely omitted by older backends. */
  name: z.string().nullable().optional(),
  enabled: z.boolean(),
  inclusionMode: pricingInclusionMode,
  markupRate: z.string(),
  lastSyncedAt: z.date().nullable(),
});

export const redoMarketCountryOutput = z.object({
  id: redoMarketCountryIdFormat.schema,
  marketId: redoMarketIdFormat.schema,
  destinationCountryCode: z.string(),
  sourceMarketId: z.string(),
  sourceCatalogId: z.string(),
  sourcePriceListId: z.string(),
  lastSyncedAt: z.date().nullable(),
  createdAt: z.date(),
  updatedAt: z.date(),
});

export const marketWithCountriesOutput = z.object({
  market: redoMarketOutput,
  countries: z.array(redoMarketCountryOutput),
});
